module.exports = __webpack_public_path__ + "media/images/mailer/notifications-48-primary-14d1279efa0cdfd116141ec352050013.png";